import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

//this service provide observable that indicate if there is a load operation in the application at current time
//it used by the loader interceptor to update the observers
@Injectable({
    providedIn: 'root',
})
export class LoaderService implements OnDestroy {
    public isLoading = new BehaviorSubject(false);

    constructor() {}
    ngOnDestroy(): void {
        if (this.isLoading) this.isLoading.unsubscribe();
    }
}
